import React, { useState } from 'react';
import { MenuBook } from '@mui/icons-material';
import { Tooltip } from '@mui/material';

import { Campaign } from "@dndModels";

import ModalOrDrawer from "@components/display/ModalOrDrawer";
import RulesReference from "@dndComponents/campaign/rules/RulesReference";

interface Props {
  campaign?: Campaign;
}

export default function RulesReferenceButton({
  campaign,
}: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title="Rules Reference">
        <MenuBook className="clickable"
          onClick={() => { setOpen(true); }}
        />
      </Tooltip>
      <ModalOrDrawer
        open={ open }
        width="720px"
        onClose={() => {
          setOpen(false);
        }}>
        { open &&
          <RulesReference campaign={campaign} />
        }
      </ModalOrDrawer>
    </>
  );
}
